import { irm_templateInfo } from 'owa-locstrings/lib/strings/irm_templateinfo.locstring.json';
import {
    warningUpgradeMessage,
    warningFailedToShowOriginalMessage,
    errorMessageInvalidSenderMailCanNotBeSend,
    warningMessageMaxRecipientsExceed,
    errorMessageNoPermissionToSendAs,
    errorMessageSubmissionQuotaExceededMessageCanNotBeSent,
    errorMessageItemNoLongerExistToSend,
    errorMessageItemNoLongerExistToSave,
    warningMessageNoPermissionToPerformAction,
    errorMessageQuotaExceededMessageCanNotBeSent,
    errorMessageQuotaExceededMessageCanNotBeSaved,
    errorMessageMessageCanNotBeSaved,
    error500,
    error503,
    errorFailedToFetch,
    errorSessionTimeout,
    errorMailboxStoreUnavailable,
    errorMessageAccountSuspend,
    errorMessageExceededMaxRecipientLimitPremium,
    errorMessageExceededMaxRecipientLimit,
    errorMessageExceededMessageLimitPremium,
    errorMessageExceededMessageLimit,
    errorMessageExceededHourlyMessageLimit,
    errorMessageMessageBlocked,
    errorMessageMessageSubmissionBlocked,
    errorMessageAccountSuspendShowTierUpgrade,
    errorMessageExceededMaxRecipientLimitShowTierUpgrade,
    errorMessageExceededMessageLimitShowTierUpgrade,
    errorMessageTransientError,
    cmpEncryptMessage,
    cmpEncryptMessageDNF,
    cmpEncryptionDlpPolicyTips,
    policyTipsPrefix,
    policyTipsUndoLink,
    cmpEncryptionTips,
    cmpDlpConfirmEncryption,
    UnableToSaveMessage,
    smimeComposeHasIRM,
    dictationSilenceBusinessBarMessage,
    messageClassificationInfoBarMessage,
} from './getInfoBarMessageViewState.locstring.json';
import { errorMessageMessageCanNotBeSent } from '../strings.locstring.json';
import { errorMessageNoRecipentsMailCanNotBeSend } from 'owa-locstrings/lib/strings/errormessagenorecipentsmailcannotbesend.locstring.json';
import loc, { format } from 'owa-localize';
import { ComposeViewState, ComposeOperation, getStore } from 'owa-mail-compose-store';
import getInfoBarMessageCreator from 'owa-info-bar/lib/utils/infoBarMessageCreatorsMap';
import { getInfoBarViewState, AttachmentPolicyInfoBarId } from 'owa-attachment-policy';

import protectMessage from '../actions/protectMessage';
import removeInfoBarMessage from '../actions/removeInfoBarMessage';
import removeProtection from './removeProtection';
import getRemoveClassificationLink from 'owa-mail-message-classification/lib/utils/getRemoveClassificationLink';
import removeRecipientsFromRecipientWells from 'owa-readwrite-recipient-well/lib/actions/removeRecipientsFromRecipientWells';
import setIsFalsePositive from 'owa-policy-tips/lib/actions/setIsFalsePositive';
import setOverrideJustification from 'owa-policy-tips/lib/actions/setOverrideJustification';
import shouldDisableEncryptionButton from './shouldDisableEncryptionButton';

import { createModifyProtectionInfoBarCustomAction } from './modifyProtectionInfoBarCustomAction';
import { ENCRYPT_GUID } from '../store/schema/EncryptionGUID';

import { getPolicyTipsCustomAction } from 'owa-policy-tips/lib/utils/getPolicyTipsCustomAction';
import { getPolicyTipsInfoBarMessage } from 'owa-policy-tips/lib/utils/getPolicyTipsInfoBarMessage';
import { getSensitivityInfoBarMessage } from 'owa-mail-sensitivity';
import { getUserConfiguration } from 'owa-session-store';
import {
    getAllRecipients,
    getRecipientWellsFromComposeViewState,
} from '../utils/getAllRecipientsAsEmailAddressStrings';
import {
    InfoBarMessageSource,
    InfoBarMessageRank,
    InfoBarMessageViewState,
    InfoBarCustomAction,
    MessagePart,
} from 'owa-info-bar/lib/schema/InfoBarMessageViewState';
import {
    getUpgradeToPremiumButton,
    getHipVerifyButton,
    getAccountRecoveryFlowButton,
} from './wasclUtils';
import getSmimeEncodeErrorInfoBarMessage from 'owa-smime/lib/utils/getSmimeEncodeErrorInfoBarMessage';
import getSmimeControlErrorInfobarMessage from 'owa-smime/lib/utils/getSmimeControlErrorInfobarMessage';
import SmimeContext from 'owa-smime/lib/store/schema/SmimeContext';
import isCLPEnabled from 'owa-mail-clp/lib/utils/isCLPEnabled';

const ENCRYPT_LEARN_MORE = 'https://go.microsoft.com/fwlink/?linkid=867644';

function createInfoBarViewState(
    messageId: string,
    messages: MessagePart[],
    rank: InfoBarMessageRank = InfoBarMessageRank.Error
): InfoBarMessageViewState {
    return {
        key: messageId,
        source: InfoBarMessageSource.Compose,
        rank: rank,
        messageParts: messages,
    };
}

export default function getInfoBarMessageViewState(
    messageId: string,
    composeViewState: ComposeViewState
): InfoBarMessageViewState {
    let messages: MessagePart[] = [];
    let rank: InfoBarMessageRank;
    const { composeId } = composeViewState;
    const isPremiumConsumerMailbox = getUserConfiguration().SessionSettings
        .IsPremiumConsumerMailbox;
    const infoBarMessageViewCreator = getInfoBarMessageCreator(composeId, messageId);
    if (infoBarMessageViewCreator) {
        if (typeof infoBarMessageViewCreator === 'function') {
            return infoBarMessageViewCreator(composeViewState);
        } else {
            messages = infoBarMessageViewCreator;
        }
    } else {
        switch (messageId) {
            // UpConvert / Upgrade
            case 'warningNoQuotedBody':
                messages = [loc(warningUpgradeMessage)];
                break;
            case 'warningFailureToShowOriginalMessage':
                messages = [loc(warningFailedToShowOriginalMessage)];
                break;

            // Client send validation
            case 'errorMessageNoRecipentsMailCanNotBeSend':
                messages = [loc(errorMessageNoRecipentsMailCanNotBeSend)];
                break;
            case 'errorMessageInvalidSenderMailCanNotBeSend':
                messages = [loc(errorMessageInvalidSenderMailCanNotBeSend)];
                break;
            case 'warningMessageMaxRecipientsExceed':
                messages = [loc(warningMessageMaxRecipientsExceed)];
                break;
            case 'errorMessageFileCanNotBeSaved':
                messages = [loc(UnableToSaveMessage)];
                break;

            // Server side error message
            case 'errorMessageNoPermissionToSendAs':
                messages = [loc(errorMessageNoPermissionToSendAs)];
                break;
            case 'errorMessageSubmissionQuotaExceededMessageCanNotBeSent':
                messages = [loc(errorMessageSubmissionQuotaExceededMessageCanNotBeSent)];
                break;

            case 'errorMessageItemNoLongerExistToSend':
                messages = [loc(errorMessageItemNoLongerExistToSend)];
                break;
            case 'errorMessageItemNoLongerExistToSave':
                messages = [loc(errorMessageItemNoLongerExistToSave)];
                break;
            case 'warningMessageNoPermissionToPerformAction':
                messages = [loc(warningMessageNoPermissionToPerformAction)];
                break;
            case 'errorMessageQuotaExceededMessageCanNotBeSent':
                messages = [loc(errorMessageQuotaExceededMessageCanNotBeSent)];
                break;
            case 'errorMessageQuotaExceededMessageCanNotBeSaved':
                messages = [loc(errorMessageQuotaExceededMessageCanNotBeSaved)];
                break;
            case 'errorMessageMessageCanNotBeSent':
                messages = [loc(errorMessageMessageCanNotBeSent)];
                break;
            case 'errorMessageMessageCanNotBeSaved':
                messages = [loc(errorMessageMessageCanNotBeSaved)];
                break;
            case 'error500':
                messages = [loc(error500)];
                break;
            case 'error503':
                messages = [loc(error503)];
                break;
            case 'errorFailedToFetch':
                messages = [loc(errorFailedToFetch)];
                break;
            case 'errorSessionTimeout':
                messages = [loc(errorSessionTimeout)];
                break;
            case 'errorMailboxStoreUnavailable':
                messages = [loc(errorMailboxStoreUnavailable)];
                break;

            // Wascl related error message
            case 'errorMessageAccountSuspend':
                messages = [
                    loc(errorMessageAccountSuspend),
                    getAccountRecoveryFlowButton(composeViewState),
                ];
                break;
            case 'errorMessageExceededMaxRecipientLimit':
                if (isPremiumConsumerMailbox) {
                    messages = [loc(errorMessageExceededMaxRecipientLimitPremium)];
                } else {
                    messages = [
                        loc(errorMessageExceededMaxRecipientLimit),
                        getUpgradeToPremiumButton(composeViewState),
                    ];
                }
                break;
            case 'errorMessageExceededMessageLimit':
                if (isPremiumConsumerMailbox) {
                    messages = [loc(errorMessageExceededMessageLimitPremium)];
                } else {
                    messages = [
                        loc(errorMessageExceededMessageLimit),
                        getUpgradeToPremiumButton(composeViewState),
                    ];
                }
                break;
            case 'errorMessageExceededHourlyMessageLimit':
                messages = [loc(errorMessageExceededHourlyMessageLimit)];
                break;
            case 'errorMessageMessageBlocked':
                messages = [loc(errorMessageMessageBlocked)];
                break;
            case 'errorMessageMessageSubmissionBlocked':
                messages = [
                    loc(errorMessageMessageSubmissionBlocked),
                    getHipVerifyButton(composeViewState),
                ];
                break;
            case 'errorMessageAccountSuspendShowTierUpgrade':
                messages = [
                    loc(errorMessageAccountSuspendShowTierUpgrade),
                    getAccountRecoveryFlowButton(composeViewState),
                ];
                break;
            case 'errorMessageExceededMaxRecipientLimitShowTierUpgrade':
                messages = [
                    loc(errorMessageExceededMaxRecipientLimitShowTierUpgrade),
                    getHipVerifyButton(composeViewState),
                ];
                break;
            case 'errorMessageExceededMessageLimitShowTierUpgrade':
                messages = [
                    loc(errorMessageExceededMessageLimitShowTierUpgrade),
                    getHipVerifyButton(composeViewState),
                ];
                break;

            case 'errorMessageTimeout':
                messages = [format(loc(errorMessageTransientError), '(0x00000002)')];
                break;

            case 'errorMessageThrottled':
                messages = [format(loc(errorMessageTransientError), '(0x00000008)')];
                break;

            case 'errorMessageTransientError':
                messages = [format(loc(errorMessageTransientError), '(0x00004000)')];
                break;

            // IRM protection
            case 'encryption':
                messages = [loc(cmpEncryptMessage)];
                if (composeViewState.IRMData.IsOwner) {
                    messages.push(removeProtection(composeViewState, 'encryption'));
                    messages.push('|');
                }
                messages.push(getEncryptionTips());
                rank = InfoBarMessageRank.Encryption;
                break;

            case 'encryptionDoNotForward':
                messages = [loc(cmpEncryptMessageDNF)];
                if (composeViewState.IRMData.IsOwner) {
                    messages.push(removeProtection(composeViewState, 'encryptionDoNotForward'));
                    messages.push('|');
                }
                messages.push(getEncryptionTips());
                rank = InfoBarMessageRank.Encryption;
                break;

            case 'consumerDlpPolicyTips':
                messages = [loc(cmpEncryptionDlpPolicyTips)];
                // If compliance configuration is not ready, do not show the confirm encryption link
                if (!shouldDisableEncryptionButton(composeViewState, ENCRYPT_GUID)) {
                    messages.push(confirmEncryptMessage(composeViewState));
                    messages.push('|');
                }
                messages.push(getEncryptionTips());
                rank = InfoBarMessageRank.Encryption;
                break;

            case 'enterpriseDlpPolicyTips':
                const recipientWells = getRecipientWellsFromComposeViewState(composeViewState);
                const policyTipsViewState = composeViewState.policyTipsViewState;
                const infoBarMessage = getPolicyTipsInfoBarMessage(policyTipsViewState);
                messages = [loc(policyTipsPrefix), infoBarMessage];
                if (
                    policyTipsViewState.isReportedFalsePositive ||
                    policyTipsViewState.isOverridden
                ) {
                    messages.push({
                        text: loc(policyTipsUndoLink),
                        action: () => {
                            setIsFalsePositive(composeViewState.policyTipsViewState, false);
                            // Setting to null here is required, as an empty string is a valid justification for silent override.
                            setOverrideJustification(composeViewState.policyTipsViewState, null);
                        },
                    });
                    messages.push('|');
                }
                const customPart = getPolicyTipsCustomAction(
                    composeViewState.policyTipsViewState,
                    getAllRecipients(composeViewState),
                    recipients => removeRecipientsFromRecipientWells(recipients, recipientWells)
                );
                if (customPart) {
                    messages.push(customPart);
                }

                rank = InfoBarMessageRank.Encryption;
                break;

            case 'infoSensitivity':
                messages = getSensitivityInfoBarMessage(composeViewState.sensitivity);
                break;

            case 'irmInfoBar':
                const irmData = composeViewState.IRMData;
                if (irmData) {
                    const fullText = format(
                        loc(irm_templateInfo),
                        irmData.TemplateName,
                        irmData.TemplateDescription
                    );
                    messages = [fullText];
                    if (irmData.IsOwner) {
                        if (!isCLPEnabled()) {
                            messages.push(
                                createModifyProtectionInfoBarCustomAction(composeViewState)
                            );
                            messages.push('|');
                        }
                        messages.push(removeProtection(composeViewState, 'irmInfoBar'));
                    }
                    rank = InfoBarMessageRank.Encryption;
                }
                break;
            case AttachmentPolicyInfoBarId.InfoRestrictedAccess:
                return getInfoBarViewState(messageId);
            case 'errorSmimeComposeHasIRM':
                messages = [loc(smimeComposeHasIRM)];
                rank = InfoBarMessageRank.Error;
                break;
            case 'smimeEncodeError':
                const { errorCode, errorContext } = composeViewState.smimeViewState;
                return getSmimeEncodeErrorInfoBarMessage(
                    'smimeEncodeError',
                    errorCode,
                    errorContext
                );
            case 'smimeAdapterInitializationError':
                const isReplyOrReplyAll =
                    composeViewState.operation == ComposeOperation.Reply ||
                    composeViewState.operation == ComposeOperation.ReplyAll;
                const isForward = composeViewState.operation == ComposeOperation.Forward;
                return getSmimeControlErrorInfobarMessage(
                    'smimeAdapterInitializationError',
                    SmimeContext.EncodingMessage,
                    false /* isItemSigned */,
                    true /* isCompose */,
                    isReplyOrReplyAll,
                    isForward
                );
            case 'CLPLabel':
                let { selectedCLPLabel } = composeViewState.clpViewState;
                if (selectedCLPLabel) {
                    messages = [selectedCLPLabel.infobarDisplayText];
                    if (selectedCLPLabel.isEncryptingLabel) {
                        rank = InfoBarMessageRank.Encryption;
                    } else {
                        rank = InfoBarMessageRank.Sensitivity;
                    }
                }
                break;
            case 'dictationSilenceBusinessBarMessage':
                messages = [loc(dictationSilenceBusinessBarMessage)];
                break;
            case 'messageClassification':
                const { classificationViewState } = composeViewState;
                const { messageClassification } = classificationViewState;
                const { RmsV2UIEnabled } = getUserConfiguration();
                if (messageClassification) {
                    messages = [
                        format(
                            loc(messageClassificationInfoBarMessage),
                            messageClassification.Name,
                            messageClassification.Description
                        ),
                    ];
                    // When classification is not display in the setPermission dropdown,
                    // show links to change permission and remove classification
                    if (RmsV2UIEnabled) {
                        messages.push(createModifyProtectionInfoBarCustomAction(composeViewState));
                        messages.push('|');
                        messages.push(
                            getRemoveClassificationLink(
                                classificationViewState,
                                composeViewState,
                                composeViewState.composeId
                            )
                        );
                    }
                    rank = InfoBarMessageRank.Info;
                }
                break;
            default:
                break;
        }
    }

    return createInfoBarViewState(messageId, messages, rank);
}

function getEncryptionTips(): InfoBarCustomAction {
    return {
        text: loc(cmpEncryptionTips),
        action: () => {
            window.open(ENCRYPT_LEARN_MORE, '_blank');
        },
    };
}

function confirmEncryptMessage(composeViewState: ComposeViewState): InfoBarCustomAction {
    const storeState = getStore();

    return {
        text: loc(cmpDlpConfirmEncryption),
        action: () => {
            removeInfoBarMessage(composeViewState, 'consumerDlpPolicyTips');
            protectMessage(composeViewState, storeState.complianceConfigurations, ENCRYPT_GUID);
        },
    };
}
